import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Button from '@mui/material/Button'
import { Order, OrderStatus } from '../../entities/order/Order'
import GotIt from '../got-it/GotItContainer'

import { styled } from '@mui/material/styles'
import messages from './ChangeOrderStatusButton.messages'

export interface IOwnProps {
  order: Order
}
export interface IStateProps { }

export interface IDispatchProps {
  requestOrderStatusChange: (orderId: number, nextStatus: string) => void
}

export type IProps = IOwnProps & IStateProps & IDispatchProps;

const OrderStatusButton = styled(Button)({
  fontSize: 14,
  fontWeight: 400,
  padding: '5px 7px',
  borderRadius: 5,
  marginLeft: 5,
})

const ChangeOrderStatusButton:React.FC<IProps> = (props) => {
  const {
    order,
    requestOrderStatusChange,
  } = props

  const intl = useIntl()

  const handleMoveToReady = () => {
    requestOrderStatusChange(order.orderId, OrderStatus.READY_FOR_PICKUP)
  }

  return (
    <>
      {
        order.canMoveToInProgress()
          &&
          <OrderStatusButton
            aria-label={intl.formatMessage({...messages.toInProgressButton})}
            variant='outlined'
            color='warning'
            onClick={() => requestOrderStatusChange(order.orderId, OrderStatus.ACCEPTED)}
          >
            <FormattedMessage {...messages.toInProgressButton} />
          </OrderStatusButton>
      }

      {
        (!order.canRemoveFromPallet() && order.isInProgress())
          &&
          <OrderStatusButton
            aria-label={intl.formatMessage({...messages.moveReadyButton})}
            variant='outlined'
            color='warning'
            onClick={handleMoveToReady}
          >
            <FormattedMessage {...messages.moveReadyButton} />
          </OrderStatusButton>
      }

      {
        order.canRemoveFromPallet()
          &&
          <OrderStatusButton
            aria-label={intl.formatMessage({...messages.removeButton})}
            variant='outlined'
            color='warning'
            onClick={() => requestOrderStatusChange(order.orderId, OrderStatus.CANCELED)}
          >
            <FormattedMessage {...messages.removeButton} />
          </OrderStatusButton>
      }

      {
        (order.isCanceled && !order.canRemoveFromPallet() && !order.wasMovedToInProgress)
          &&
            <GotIt
              orderId={order.orderId}
            />
      }

      {
        (order.wasMovedToInProgress)
          &&
            <GotIt
              reason={intl.formatMessage({...messages.reason})}
              orderId={order.orderId}
            />
      }

    </>
  )
}

export default ChangeOrderStatusButton
